import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
// pc-header 还在用，暂时不能删除
export var ConfigItem = /*#__PURE__*/function () {
  function ConfigItem() {
    _classCallCheck(this, ConfigItem);
  }

  _createClass(ConfigItem, null, [{
    key: "getKey",
    value: function getKey(propName) {
      if (this.configName === '') {
        throw new Error('子类未重命名configName!');
      }

      return "".concat(this.configName, ".").concat(propName);
    }
  }]);

  return ConfigItem;
}();

_defineProperty(ConfigItem, "configName", '');
//# sourceMappingURL=config-constants.js.map